@if (($papeis().length > 0 || $papelOptions().length > 0) && $currentUser() != null) {
    <div class="form-group w-100 m-0 pb-2" [class.formio-error-wrapper]="!papelElem.valid && !$isReadOnly()">
        <label for="papelAssinanteId" class="font-weight-bold mr-2">
            Papel utilizado para {{$flowObjectType() == FlowObjectType.TaskRegisterProcess
                ? 'autuar o processo no E-Docs'
                : $flowObjectType() == FlowObjectType.TaskDispatchProcess
                    ? 'despachar o processo no E-Docs'
                    : $flowObjectType() == FlowObjectType.GatewayPaths
                        ? 'executar a Tarefa'
                        : 'capturar o(s) documento(s) da Tarefa no E-Docs'
            }}
        </label>
        <select class="form-control info-font light" id="papelAssinanteId" name="papelAssinanteId" required #papelElem="ngModel" #papelRef
                [ngModel]="$signerId()"
                [disabled]="$isReadOnly()"
                (change)="onChange($event.target.value)"
        >
            @for (option of $papelOptions(); track option) {
                <option [value]="option.value">{{option.description}}</option>
            }
        </select>
    </div>
}
